import { atom, useRecoilState } from 'recoil';
import { JwtApi } from '../misc/api/jwt';
import SessionManagerFactory from '../misc/session';
import { cleanLocalStorageCache } from '../utils/localStorage.utils';
import { useSessionStorage } from './useSessionStorage';

const SessionManager = SessionManagerFactory();

const isLoggedAtom = atom({
  key: 'isLoggedAtom',
  default: !SessionManager.hasEmptySession(),
});

export const useLogin = () => {
  const [isLogged, setIsLogged] = useRecoilState(isLoggedAtom);

  const login = ({ email, password }) =>
    JwtApi.service
      .login(email, password)
      .then(response => {
        /* if response is not 200, then it has not been authorised */
        if (response?.token) {
          return response?.token;
        }
        throw new Error('No token');
      })
      .then(sessionToken => {
        SessionManager.setRootToken(sessionToken);
        const roleManager = SessionManager.getRoleManager();
        const success =
          roleManager.isGlobalAdmin() ||
          roleManager.isAccountAdmin() ||
          roleManager.isAccountUser();
        if (!success) {
          throw new Error('No permissions');
        } else {
          setIsLogged(true);
        }
      });

  const logout = ({ callback, onError = () => {} }) => {
    const token = SessionManager.getUser()?.id;
    const { removeRegexKeys } = useSessionStorage();

    JwtApi.service.externalAction
      .logout({ token })
      .then(() => {
        cleanLocalStorageCache();
        SessionManager.cleanSession();

        removeRegexKeys(/subhomeFilters-[a-zA-Z]*/);

        callback();
        setIsLogged(false);
        window.location.reload(true);
      })
      .catch(() => {
        console.info('LogOut Error');
        onError();
      });
  };

  return {
    login,
    logout,
    isLogged,
  };
};
